import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
// Asegúrate de que esta utilidad exista en tu proyecto
import { formatearFechaCompleta, formatearFechaCorta, formatearPrecio } from '../../../utils/utils'; 

// ===================================================================================
// FUNCIÓN PRINCIPAL PARA GENERAR LA CUENTA DE COBRO DEL TUTOR
// ===================================================================================
const generarPdfCuentaCobroTutor = async(serviciosParaPagar,usuario,idPago) => {

  // Asignamos la lista de servicios recibida a la variable que usa el resto del script
  const servicios = serviciosParaPagar;

  // --- 2. Configuración Inicial del Documento ---
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const margin = 15;
  let currentY = 10;

  const paleta = {
    primario: '#2A5297', // Un azul corporativo similar al de la imagen
    textoBlanco: '#FFFFFF',
    textoPrincipal: '#333333',
    textoSecundario: '#555555',
    borde: '#DDDDDD',
  };

  // --- 3. Cálculo del Total ---
  const totalAPagar = servicios.reduce((sum, item) => sum + item.preciotutor, 0);

  // =================================================================================
  // SECCIÓN 1: ENCABEZADO PRINCIPAL (BARRA AZUL)
  // =================================================================================
  doc.setFillColor(paleta.primario);
  doc.rect(margin, currentY, pageWidth - (margin * 2), 20, 'F');

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(20);
  doc.setTextColor(paleta.textoBlanco);
  doc.text('CUENTA DE COBRO', margin + 10, currentY + 13);

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(14);
  doc.text('A PAGAR', pageWidth - margin - 50, currentY + 8, { align: 'right' });
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.text(formatearPrecio(totalAPagar), pageWidth - margin - 10, currentY + 15, { align: 'right' });
  
  currentY += 30;

  // =================================================================================
  // SECCIÓN 2: INFORMACIÓN GENERAL (TUTOR, EMPRESA Y DATOS DE LA CUENTA)
  // =================================================================================
  const infoCol1X = margin;
  const infoCol2X = pageWidth / 2;

  // --- Información del Tutor ---
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(paleta.textoPrincipal);
  doc.text('INFORMACIÓN DE TUTOR', infoCol1X, currentY);
  
  let infoY = currentY + 6;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(paleta.textoSecundario);
  doc.text(`Nombre: ${usuario.nombreCompleto}`, infoCol1X, infoY);
  doc.text(`Cédula: ${usuario.identificacionTutor}`, infoCol1X, infoY += 5);
  doc.text(`Número de celular: ${usuario.numeroWhatsapp}`, infoCol1X, infoY += 5);
  doc.text(`Email: ${usuario.correogmail}`, infoCol1X, infoY += 5);
  
  // --- Datos de la Cuenta de Cobro ---
  const fechaFormateada = formatearFechaCompleta(new Date());
  doc.setFont('helvetica', 'normal');
  doc.text(`Id cuenta Cobro: ${idPago}`, infoCol2X, currentY + 6);
  doc.text(`Fecha expedición: ${fechaFormateada}`, infoCol2X, currentY + 11);

  currentY = infoY + 10;

  // --- Información de la Empresa ---
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(paleta.textoPrincipal);
  doc.text('INFORMACIÓN DE EMPRESA', infoCol1X, currentY);

  infoY = currentY + 6;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(paleta.textoSecundario);
  doc.text(`Nombre Empresa: DUFY ASESORÍAS`, infoCol1X, infoY);
  doc.text(`Nombre: : Andrés Eduardo Duran Sánchez`, infoCol1X, infoY += 5);
  doc.text(`CC: 1007367243`, infoCol1X, infoY += 5);
  doc.text(`Número de celular: 316 5585 420`, infoCol1X, infoY += 5);

  currentY = infoY + 15;

  // =================================================================================
  // SECCIÓN 3: TABLA DE SERVICIOS
  // =================================================================================
  const tableBody = servicios.map(servicio => [
    servicio.codigo,
    `${servicio.identificadorcodigo} - ${servicio.materia}`,
    formatearFechaCorta(servicio.fechaentrega),
    formatearPrecio(servicio.preciotutor)
  ]);

  autoTable(doc, {
    startY: currentY,
    head: [['Código', 'Concepto', 'Fecha de entrega', 'Total']],
    body: tableBody,
    theme: 'grid',
    headStyles: {
      fillColor: paleta.primario,
      textColor: paleta.textoBlanco,
      fontStyle: 'bold',
    },
    styles: {
      fontSize: 9,
      cellPadding: 3,
      textColor: paleta.textoPrincipal,
      valign: 'middle'
    },
    columnStyles: {
      0: { cellWidth: 35 },
      1: { cellWidth: 'auto' },
      2: { halign: 'center' },
      3: { halign: 'right' }
    },
    // Eliminamos el hook didDrawPage de aquí
  });

  // --- Lógica del Total de Pago (MOVIDA FUERA Y DESPUÉS DE AUTOTABLE) ---
  // Ahora doc.lastAutoTable SÍ existe y podemos usarlo de forma segura.
  const finalY = doc.lastAutoTable.finalY;
  
  doc.setDrawColor(paleta.borde);
  doc.line(margin, finalY, pageWidth - margin, finalY);
  
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.text('Total de Pago', margin + 135, finalY + 7, { align: 'right' });
  doc.text(formatearPrecio(totalAPagar), pageWidth - margin - 3, finalY + 7, { align: 'right' });
  
  // Actualizamos currentY para la sección de firmas
  currentY = finalY + 20;

  // =================================================================================
  // SECCIÓN 4: FIRMAS
  // =================================================================================
  const signatureY = doc.internal.pageSize.height - 50;
  const signatureBlockWidth = (pageWidth - margin * 2) / 2.5;

  const firmaClienteX_start = margin + 10;
  const firmaClienteX_end = firmaClienteX_start + signatureBlockWidth;
  doc.line(firmaClienteX_start, signatureY, firmaClienteX_end, signatureY);
  doc.setFontSize(10);
  doc.setTextColor(paleta.textoPrincipal);
  doc.text('Firma del tutor', firmaClienteX_start + signatureBlockWidth / 2, signatureY + 5, { align: 'center' });

  const firmaEmpresaX_end = pageWidth - margin - 10;
  const firmaEmpresaX_start = firmaEmpresaX_end - signatureBlockWidth;
  doc.line(firmaEmpresaX_start, signatureY, firmaEmpresaX_end, signatureY);
  doc.text('Firma de la Empresa', firmaEmpresaX_start + signatureBlockWidth / 2, signatureY + 5, { align: 'center' });


  // =================================================================================
  // SECCIÓN 5: GUARDAR EL DOCUMENTO
  // =================================================================================
  const nombreArchivo = `Cuenta_Cobro_${idPago}_${usuario.nombreCompleto}.pdf`;
  doc.save(nombreArchivo);
};

export default generarPdfCuentaCobroTutor;